import React, { createContext, useContext, useEffect, useState } from 'react';
import { useRestaurant } from './restaurant.context';
import { useDispatch, useSelector } from 'react-redux';
import { setSessionSettingsStorage } from '../store/session-storage';
import { cartResetSpecialCategory, cartSetSpecialCategory, resetCart, setCart } from '../store/actions/cart.actions';

const Context = createContext({});

export const useSettings = () => useContext(Context);

export const SettingsProvider = React.memo(({ children }) => {
    const [settings, setSettings] = useState({});

    const restaurant = useRestaurant();
    const categories = restaurant.menu_categories;

    const cart = useSelector(state => state.cart.items);
    const specialCategory = useSelector(state => state.cart.specialCategory);

    const dispatch = useDispatch();

    useEffect(() => {
        if (window.group_id) {
            setSessionSettingsStorage('action', window.action);
            setSessionSettingsStorage('group_id', window.group_id);
            setSessionSettingsStorage('group_type', window.group_type);
            setSessionSettingsStorage('client_id', window.client_id);
            setSessionSettingsStorage('group_starter_name', window.group_starter_name);
        }

        if (window.group_cart) {
            dispatch(setCart(window.group_cart));
        }
    }, []);

    useEffect(() => {
        if (categories.length === 0 || cart.length === 0) {
            return;
        }

        const category = categories.find((category, index) => category.items.some((it) => it.id === cart[0].id));
        if (!category) {
            dispatch(resetCart());
            dispatch(cartResetSpecialCategory());
            return;
        }

        if (category.is_forced_schedule && !specialCategory) {
            dispatch(cartSetSpecialCategory(category));
        }
        else if (!category.is_forced_schedule) {
            dispatch(cartResetSpecialCategory());
        }
    }, [categories, cart]);
    
    return (
        <Context.Provider value={settings}>
            {children}
        </Context.Provider>
    );
});
